<template>
	<div class="pageWrapper">
		<el-row>
			<el-col :span="10">
				<div class="panel actionPanel">
					<img class="logo" src="../assets/primaryLogo.svg" />
					<div class="resetPasswordForm">
						<h1 style="font-weight: bold">Reset Your Password</h1>
						<p>Please enter a new password.</p>
						<el-divider></el-divider>
						<el-alert
							v-if="resetSuccess"
							:closable="false"
							style="margin-bottom: 12px"
							title="Success"
							:description="
								'Password successfully reset. Redirecting you to the login page in ' +
								countDownCounter +
								's'
							"
							type="success"
							show-icon
						>
						</el-alert>
						<el-alert
							v-if="resetError"
							:closable="false"
							style="margin-bottom: 12px"
							title="Unable to reset password"
							:description="errorMessage"
							type="error"
							show-icon
						>
						</el-alert>
						<el-form
							ref="form"
							@keyup.native.enter="resetPass"
							:rules="formRules"
							label-position="top"
							label-width="100px"
							:model="resetPasswordForm"
						>
							<el-form-item prop="newPassword" label="New Password">
								<el-input
									placeholder="myStrongPassword99"
									type="password"
									v-model="resetPasswordForm.newPassword"
								></el-input>
							</el-form-item>
							<el-form-item prop="newPasswordConfirmation" label="Confirm New Password">
								<el-input
									placeholder="myStrongPassword99"
									type="password"
									v-model="resetPasswordForm.newPasswordConfirmation"
								></el-input>
							</el-form-item>
							<el-form-item>
								<el-button
									@click="resetPass"
									:disabled="
										!resetPasswordForm.newPassword ||
										!resetPasswordForm.newPasswordConfirmation ||
										!passwordIsValid ||
										resetSuccess
											? true
											: false
									"
									:loading="operationInProgress"
									style="width: 100%; margin-top: 12px"
									type="primary"
									>Reset Password</el-button
								>
							</el-form-item>
							<el-form-item>
								<div style="text-align: center">
									Remembered your password?
									<el-button @click="$router.push('/login')" style="position: relative" type="text"
										>Log in now <img class="underline" src="../assets/underline.svg"
									/></el-button>
								</div>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</el-col>
			<el-col :span="14">
				<div class="panel contentPanel"><mediaCarousel /></div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import mediaCarousel from "../components/mediaCarousel.vue";
import { httpHelper } from "../utils/httpHelper.js";
import { passwordMeetsMinRequirements } from "../utils/validation.js";
import jwt_decode from "jwt-decode";
let $this;
export default {
	components: {
		mediaCarousel,
	},
	data() {
		const validatePassword = (rule, value, callback) => {
			if (!passwordMeetsMinRequirements(value).passed) {
				$this.passwordIsValid = false;
				return callback(new Error(passwordMeetsMinRequirements(value).error));
			} else {
				$this.passwordIsValid = true;
				return callback();
			}
		};
		return {
			countDownCounter: 5,
			passwordIsValid: false,
			errorMessage: "An unknown error occured",
			resetSuccess: false,
			resetError: false,
			operationInProgress: false,
			resetPasswordForm: { newPassword: "", newPasswordConfirmation: "" },
			formRules: {
				newPassword: [
					{ required: true, message: "A new password is required", trigger: "change" },
					{ validator: validatePassword, trigger: "change" },
				],
				newPasswordConfirmation: [
					{ required: true, message: "Password confirmation is required", trigger: "change" },
				],
			},
		};
	},
	beforeMount() {
		$this = this;
	},
	methods: {
		startRedirectCountdown() {
			const interval = setInterval(() => {
				this.countDownCounter = this.countDownCounter - 1;
			}, 1000);
			setTimeout(() => {
				clearInterval(interval);
				this.$router.push("/login").catch(() => {});
			}, 5000);
		},
		resetPass() {
			if (this.resetSuccess) {
				return;
			}
			this.formRules.newPasswordConfirmation.length === 2
				? this.formRules.newPasswordConfirmation.splice(1, 1)
				: null;
			if (this.resetPasswordForm.newPasswordConfirmation !== this.resetPasswordForm.newPassword) {
				this.formRules.newPasswordConfirmation.push({
					validator: (rule, value, callback) => {
						return callback(new Error("Confirmation does not match new password"));
					},
					trigger: "manual",
				});
				this.$refs.form.validate();
				return;
			}
			this.resetError = false;
			this.resetSuccess = false;
			this.$refs.form.validate(async (valid) => {
				if (valid) {
					this.operationInProgress = true;
					const token = this.$route?.params?.token;
					let userID;
					try {
						userID = jwt_decode(token)._id;
					} catch {
						userID = null;
					}
					const form = { userId: userID, token: token, password: this.resetPasswordForm.newPassword };
					const result = await httpHelper("RUNTIME", "POST", "security/executePasswordReset", form);
					setTimeout(() => {
						this.operationInProgress = false;
						if (!result?.error) {
							this.resetSuccess = true;
							this.resetError = false;
							this.startRedirectCountdown();
						} else {
							if (result.status === 410) {
								this.errorMessage = "Reset password link has expired";
							} else if (result.status === 401) {
								this.errorMessage = "Unauthorised operation";
							} else {
								this.errorMessage = "An unknown error occured";
							}
							this.resetSuccess = false;
							this.resetError = true;
						}
					}, 500);
				} else {
					return;
				}
			});
		},
	},
};
</script>

<style scoped>
.pageWrapper {
	height: 100vh;
	width: 100vw;
	text-align: left;
}

.panel {
	height: 100vh;
	width: 100%;
}

.logo {
	height: 40px;
	margin-left: 20px;
	margin-top: 20px;
}

.actionPanel {
	background-color: white;
}

.contentPanel {
	background-color: #f5f7f9;
}

.resetPasswordForm {
	width: 70%;
	max-width: 400px;
	display: block;
	margin: auto;
	margin-top: 15%;
}

.underline {
	height: 8px;
	position: absolute;
	top: 35px;
	left: 0px;
}
</style>
